import Route from '@ember/routing/route';
import { macroCondition, isDevelopingApp } from '@embroider/macros';
import { service } from '@ember/service';
import { variation } from 'ember-launch-darkly';

export default class CloudOrgsDetailProjectsDetailIndexRoute extends Route {
  @service api;
  @service abilities;
  @service billing;
  @service userContext;

  async model() {
    const { organization, project, billing } = this.userContext;

    let resources = [];
    // TODO: HVT-7537 After HVS reaches EOL, remove query for secretsApp
    let secretsApps = [];

    if (this.abilities.can('list resources')) {
      try {
        ({ resources } =
          await this.api.resourceManager.resources.resourceServiceList(
            'PROJECT',
            project.id
          ));
        // TODO: HVT-7537 After HVS reaches EOL, remove query for secretsApp
        if (variation('hvs-eos-eol')) {
          const { apps } = await this.api.secrets.listApps(
            organization?.id,
            project?.id
          );
          secretsApps = apps || [];
        }
      } catch (e) {
        if (macroCondition(isDevelopingApp())) {
          console.error(e);
        }
      }
    }

    return {
      organization,
      project,
      resources,
      billing,
      secretsApps,
    };
  }
}
